<cdk-virtual-scroll-viewport
  [itemSize]="48"
  *ngIf="query && query.length && viewGraph"
  [style.height.px]="searchHeight">
  
  <div *cdkVirtualFor="let node of searchResults; trackBy: trackTreeNode">
    <app-tree-nested-node
      style="height: 48px; margin-right: 16px"
      [theme]="theme"
      [node]="node"
      [graph]="viewGraph"
      [nested]="false">
    </app-tree-nested-node>
  </div>
</cdk-virtual-scroll-viewport>